import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useQuery } from "react-query";
import { estateApi } from "../services/api";

const EstateContext = createContext(null);

export const EstateProvider = ({ children }) => {
  const { data = [], isLoading } = useQuery("shell-estates", estateApi.getAll);
  const estates = Array.isArray(data) ? data : [];
  const [selectedEstateId, setSelectedEstateId] = useState(() => localStorage.getItem("selectedAdminEstate") || "");

  useEffect(() => {
    if (!estates.length) return;
    const isValid = estates.some((estate) => (estate._id || estate.id) === selectedEstateId);
    if (!isValid) setSelectedEstateId(estates[0]._id || estates[0].id);
  }, [estates, selectedEstateId]);

  useEffect(() => {
    if (selectedEstateId) localStorage.setItem("selectedAdminEstate", selectedEstateId);
  }, [selectedEstateId]);

  const selectedEstate = useMemo(
    () => estates.find((estate) => (estate._id || estate.id) === selectedEstateId) || null,
    [estates, selectedEstateId],
  );

  return <EstateContext.Provider value={{ estates, selectedEstate, selectedEstateId, setSelectedEstateId, isLoading }}>{children}</EstateContext.Provider>;
};

export const useEstate = () => {
  const context = useContext(EstateContext);
  if (!context) throw new Error("useEstate must be used inside EstateProvider");
  return context;
};
